import { configureStore, Reducer, Action } from "@reduxjs/toolkit";
import { log } from "../utils";

// Function to create a static reducer
function createStaticReducer<TState, TAction extends Action>(state: TState): Reducer<TState, TAction> {
    return (oldState: TState = state, action: TAction) => {
        log("static reducer", oldState, action);
        return oldState;
    };
}

// Function to create the store using @reduxjs/toolkit's configureStore
export function createStaticStore<TState, TAction extends Action>(state: TState) {
    const reducer = createStaticReducer<TState, TAction>(state);

    const store = configureStore({
        reducer,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                thunk: true, // Thunk is included by default, this is just for explicitness
            }),
        devTools: process.env.NODE_ENV !== 'production', // Redux DevTools in non-production environments
    });

    return store;
}
